import NotificationsService from '@/api/client/notifications.service'
import router from '@/router'

const NOTIFICATION_STATUS = {
  NEW: 0,
  READ: 1,
  CLICKED: 2,
  DELETED: 3,
}

export default {
  state: {
    notifications: [{}],
    page: 0,
    accountId: '0',
    totalUnreadNotificationsCount: 0,
  },
  getters: {
    notificationList: state => state.notifications,
    totalUnreadNotificationsCount: state => state.totalUnreadNotificationsCount,
  },
  actions: {
    async getNotifications({ commit, state }, page = null) {
      if (page !== null) { state.page = page }
      if (state.accountId !== router.currentRoute.params.accountId) {
        state.accountId = router.currentRoute.params.accountId
        state.page = 0
        state.notifications = [{}]
      }
      const response = await NotificationsService.getNotifications(state.page, router.currentRoute.params.accountId)
      commit('setNotifications', response.notifications)
      commit('setTotalUnreadNotificationsCount', response.totalUnreadNotificationsCount)
      return response
    },
    async readAll({ commit }) {
      const response = await NotificationsService.readAllNotifications(router.currentRoute.params.accountId)
      commit('setTotalUnreadNotificationsCount', response.totalUnreadNotificationsCount)
      if (response.updated) {
        commit('readAllNotifications')
      }
      return response
    },
    async update({ commit }, data) {
      const response = await NotificationsService.updateNotification(data.notificationId, data.status)
      commit('setTotalUnreadNotificationsCount', response.totalUnreadNotificationsCount)
      if (response.updated) {
        commit('updateNotificationStatus', data.notificationId)
      }
      return response
    },
    async delete({ commit }, notificationId) {
      const response = await NotificationsService.deleteNotifcation(notificationId)
      commit('setTotalUnreadNotificationsCount', response.totalUnreadNotificationsCount)
      if (response.updated) {
        commit('deleteNotification', notificationId)
      }
      return response
    },
  },
  mutations: {
    setNotifications: (state, notifications) => {
      if (state.page === 0) {
        state.notifications = notifications
      } else {
        state.notifications.push(...notifications)
      }
      state.page += 1
    },
    setTotalUnreadNotificationsCount: (state, totalUnreadNotificationsCount) => {
      state.totalUnreadNotificationsCount = totalUnreadNotificationsCount
    },
    readAllNotifications: state => {
      state.notifications = state.notifications.map(x => {
        if (x.status === NOTIFICATION_STATUS.NEW) {
          x.status = NOTIFICATION_STATUS.READ
        }
        return x
      })
    },
    updateNotificationStatus: (state, notificationId) => {
      state.notifications = state.notifications.map(x => {
        if (x.id === notificationId) {
          x.status = NOTIFICATION_STATUS.CLICKED
        }
        return x
      })
    },
    deleteNotification: (state, notificationId) => {
      state.notifications = state.notifications.filter(x => x.id !== notificationId)
    },
  },
}
